<template>
  <div>
   <ModalHistory ref="ModalHistoryTwo" :empresaId="CompanySelected"></ModalHistory>
     <Tables ref="tableGrid"
             :columns="[
               'Lote','Data Solicitação','Solicitante', 'Funcionário','Função', 'Obra','Responsável','Regional','Viagem Motivo','Viagem Início','Viagem Fim','Cidade Origem','Cidade Destino','Situação','Total previsto','Total','Saldo','Ações']"
             :messageTipFooter="$lang.Common.ClickToSelect"
             :showPrint="false"
             :showDownload="false"
             :showCheckInput="true"
             v-on:Load="getAll"
             v-on:SaveFile="onDownload"
             @check="checkAll"
             v-on:Print="onPrint"
             v-on:ExportExcel="onExportExcel">
       <tr v-for="(obj, index) in this.objList" v-bind:key="index">
         <td class="text-center pt-4">
           <input type="checkbox" @click ="$emit('selectedId',obj.id)" :id="obj.id" class="checkboxInput">
         </td>
         <TableColumn :IsText="true"   :isTextWarning="verificarFilterDataViagem(obj)" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"  v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.lote !== null ? obj.lote : 'N/D'" />
         <TableColumn :IsDateOnly="true"
         :IsDateOnlyWarning="verificarFilterDataViagem(obj)"
                     v-on:Edit="onEdit(obj)"
                      :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.dataCriacao" />
         <TableColumn :IsText="true"
         :isTextWarning="verificarFilterDataViagem(obj)"
                     v-on:Edit="onEdit(obj)"
                      :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.solicitante.nome" />
         <TableColumn :IsText="!obj.favorecido.demissao"
         :IsTextLocked="obj.favorecido.demissao != null ? true : false"
         :isTextWarning="verificarFilterDataViagem(obj) && !obj.favorecido.demissao"
                     v-on:Edit="onEdit(obj)"
                      :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.favorecido ? obj.favorecido.nameCodigo : ''" />
         <TableColumn :IsText="true"
         :isTextWarning="verificarFilterDataViagem(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido && obj.favorecido.cargo ? obj.favorecido.cargo.nome : ''" />
         <TableColumn :IsText="true"
         :isTextWarning="verificarFilterDataViagem(obj)"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
         <TableColumn :IsText="true"
         :isTextWarning="verificarFilterDataViagem(obj)"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.responsavel ? obj.responsavel.nome : ''" />
         <TableColumn :IsText="true"
         :isTextWarning="verificarFilterDataViagem(obj)"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status"
                     :value="obj.secaoRH.nome" />
         <TableColumn :IsText="true"  :isTextWarning="verificarFilterDataViagem(obj)" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
         <TableColumn :IsDateOnly="true" :IsDateOnlyWarning="verificarFilterDataViagem(obj)" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
         <TableColumn :IsDateOnly="true" :IsDateOnlyWarning="verificarFilterDataViagem(obj)"  :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemFim" />
         <TableColumn :IsText="true"  :isTextWarning="verificarFilterDataViagem(obj)" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.origem)" />
         <TableColumn :IsText="true"  :isTextWarning="verificarFilterDataViagem(obj)" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.destino)" />
         <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status">
           <b-badge  v-if="obj.situacao !== 2 && obj.situacao < 4 && obj.situacao >= 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
           <b-badge  v-else-if="obj.situacao < 0" variant="danger" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
           <b-badge  v-else-if="obj.situacao >= 4 || obj.situacao === 2" variant="success" pill style="padding: 6px 10px 6px 10px;">{{verificarStatus(obj.situacao)}}</b-badge>
         </TableColumn>
         <TableColumn :IsCustom="true"
         :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
           <strong :style="verificarFilterDataViagem(obj) ? 'color:black': ' color: #004987'">{{formatMoney(obj.valorSolicitado)}}</strong>
         </TableColumn>
         <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status">
           <strong :style="obj.valorTotal < obj.valorSolicitado?  'color: red' :   'color: #004987'">{{formatMoney(obj.valorTotal)}}</strong>
         </TableColumn>
         <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'"
                     :status="obj.status">
           <strong :style="obj.valorTotal < obj.valorSolicitado?  'color: red' :   'color: #004987'">{{calculoValor(obj) + " " + formatMoney(obj.valorTotal - obj.valorSolicitado)}}</strong>
         </TableColumn>
         <TableColumn :IsActionsButtons="true" :classCss="verificarFilterDataViagem(obj) ? 'text-center bg-yellow' : 'text-center'" :HasChange="false" :HasDelete="obj.situacao === null || obj.situacao === 0" v-on:Delete="onDeleteBoard(obj)" />
       </tr>
       <template #header-card-actions>
         <div class="buttons-table-action">
           <button class="importaexcel mr-2" @click="showHistory"><i class="fas fa-history"></i> HISTORICO DE LOTE</button>
           <button class="importaexcel mr-2" @click="importDes('DESCONTO - ', true)"><i class="fas fa-file-excel mr-1"></i> Lote desconto</button>
           <button class="importaexcel ml-2 " @click="importDes('REEMBOLSO - ', false)"><i class="fas fa-file-excel mr-1"></i> Lote Reembolso</button>
           <button class="importaexcel ml-2 " @click="ImportExcelByIds"><i class="fas fa-file-excel mr-1"></i> EXPORTAR</button>
         </div>
       </template>
     </Tables>
  </div>
</template>

<script>
import TableTravelComision from './TableTravelComision'
export default TableTravelComision
</script>

<style scoped>
.buttons-table-action{
 width: 50vw;
 display: flex;
 justify-content: right;
 align-items: center;
}
.importaexcel{
 width: 30% !important;
 height: 80%;
 margin-right: 5px !important;
 padding-bottom: 3px;
 padding: 0px !important;
 border-radius: 10px;
 font-size: 12px;
 font-weight: bold;
 color: white !important;
 background: green  !important;
 padding-left: 4px !important;
}

.card-header .card-actions a, .card-header .card-actions button{
 margin: 5px !important;
}
.importaexcel:hover {
 background: rgb(0, 160, 0) !important
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/TableTravelComision/TableTravelComision.vue